import { isWaveTodoAgentAssignee } from "./blocks.js";
import { chatMentionsAssistant, WAVE_CHAT_AGENT_NAME, WAVE_CHAT_AGENT_SUB, } from "./waveChat.js";
import { isSameParticipantSub } from "./wavePresence.js";
import { parseTodoAssigneesFromTitle, participantMentionLabel, } from "./waveTodoMentions.js";
export { WAVE_CHAT_AGENT_NAME, WAVE_CHAT_AGENT_SUB };
/** Resolve @labels in a comment to participant subs (excludes AI agents). */
export function parseCommentParticipantSubs(body, participants) {
    return parseTodoAssigneesFromTitle(body, participants).filter((ref) => !isWaveTodoAgentAssignee(ref));
}
export function parseCommentMentions(body, participants) {
    const assignees = parseTodoAssigneesFromTitle(body, participants);
    const participantSubs = assignees.filter((ref) => !isWaveTodoAgentAssignee(ref));
    const mentionsAssistant = chatMentionsAssistant(body) || assignees.some(isWaveTodoAgentAssignee);
    return { participantSubs, mentionsAssistant };
}
export function commentMentionsParticipantSub(body, targetSub, participants) {
    const refs = parseCommentParticipantSubs(body, participants);
    return refs.some((ref) => isSameParticipantSub(ref, targetSub));
}
/** True when comment @mentions the signed-in user (by sub or mention label). */
export function commentMentionsCurrentUser(body, currentSub, participants) {
    if (commentMentionsParticipantSub(body, currentSub, participants))
        return true;
    const self = participants.find((p) => isSameParticipantSub(p.sub, currentSub));
    if (!self)
        return false;
    const label = participantMentionLabel(self).toLowerCase();
    if (!label)
        return false;
    return body.toLowerCase().includes(`@${label}`);
}
/** Strip @Assistente tokens; keep other @mentions for context. */
export function assistantPromptFromComment(body) {
    return body
        .replace(/@[\p{L}\p{N}._-]+/gu, (token) => token.slice(1).toLowerCase() === "assistente" ? "" : token)
        .replace(/\s{2,}/g, " ")
        .trim();
}
